
export default {
    menu: {
        home: '数据统计',
        goods: '商品管理',
        params: '规格参数',
        advert:'广告分类',
        order:'订单管理',
        orderlist:'订单列表',
        orderback:'退货管理'
 
    },
    home:{
        ApprovalTime:"获批时间:",
        country:"国家:",
        disease:"疾病:",
        // DrugList:"药品介绍",
        see:"查看",
        service:"服务",
        centerintro:"中心介绍",
        Expertteam:"专家团队",
        Partners:"合作机构",
        Partners2:"合作医院",
        Newsandinformation:"新闻资讯",
        Consultationcooperation:"咨询合作",
        Gocheck:"查看",
        Gocheck2:"了解更多",
        Patientcounseling:"用户咨询",
        Doctorcollaboration:"医生合作",
        Manufacturercooperation:"厂家合作",
        WeChatofficialaccount2:"扫一扫关注公众号",
        MicroBlog:"微博",
        WeChatOfficialAccount:"公众号",
        OurStory:"我们的故事",
        Diagnosisandtreatmentservices:"诊疗服务",
        Cooperativeprojects:"合作项目",
        PopularScienceInformation:"科普信息",
        AcademicFrontiers:"学术前沿",
        PatientHome:"患者之家",
        ContactUs:"联系我们",
        VisionandMission:"愿景使命",
        developmenthistory:"发展历程",
        Listsofdiseases:"疾病列表",
        DrugList:"产品中心",
        newsInfo:"新闻资讯",
        messageInfo:'留言咨询',
        Findmedicineandmedication:"找药用药",
        Globaldrugsearch:"全球找药",
        scientificresearchcooperation:"科研合作",
        Expertcooperation:"专家合作",
        Cooperation:"商业合作",
        WeiaiBaidu:"维爱百度",
        MedicalPolicy:"医药政策",
        DaKaHanHua:"大咖罕话",
        LiteratureandInformation:"文献情报",
        CaseStudy:"病例会践",
        ConferenceNewLanguage:"会议新语",
        BigCoffeeSalon:"大咖沙龙",
        readin:"读书会",
        PublicWelfareProjects:"公益项目",
        InsuranceAndPayment:"保险及支付",
        PatientStories:"患者故事",
        TransportationGuidelines:"交通指南",
        PatientCounseling:"用户咨询",
        DoctorCollaboration:"医生合作",
        ManufacturerCooperation:"厂家合作",
        CompanyAddress:"公司地址",
        understand:"立即了解",
        Address:"地址",
        Telephone:"联系电话",
        mailbox:"邮箱",
        name:"姓名",
        age:"年龄",
        contactInformation:"联系方式",
        gender:"性别",
        diagnose:"诊断疾病",
        ConsultationContentorrequiredDrugs:"咨询内容/所需药品",
        male:"男",
        female:"女",
        baomi:"保密",
        notes:"备注",
        organization:"组织",
        CooperationType:"合作类型",
        submit:"提交",
        submit1:"提交成功",
        Doctorsmessage:"医生留言",
        Cooperation:"商业合作",
        seek:"咨询",
        Topping:"顶部",
        Follow :"关 注 公 众 号",
        Follow1 :"用微信二维码关注公众号获取更多信息",
        Follow2 :"知道了",
        Follow3 :"扫描二维码关注微信公众号",
        Follow4 :"后自动关闭跳转药品列表页",
        Follow5 :"立即跳转",
        ReadAndAgree:"已阅读并同意",
        Patientinformedconsentformpolicy:"患者知情同意书&隐私政策 ",
        Please1:"请输入姓名",
        Please2:"请输入中文/英文",
        Please3:"请选择性别",
        Please4:"请输入年龄",
        Please5:"请输入数字",
        Please6:"请输入手机号或固定电话",
        Please7:"请输入邮箱",
        Please8:"请输入组织",
        Search:"搜索",
        Article:"文章",
        Video:"视频",
        Expert:"专家",
        bottom1:"全球找药、用药、咨询",
        bottom2:"学术活动、真实世界研究",
        bottom3:"临床研究、申报注册",
        bottom4:"获取更多资讯",
        CH:"中",
        login:"登录",
        Modify:"修改资料",
        logout:"退出登录",
        Bind:"绑定手机号",
        Obtain:"获取验证码",
        please:"请输入手机号",
        please1:"请你输入看到验证码",
        please2:"请输入你收到的验证码",
        save:"保存",
        logged:"未登录无法观看视频",
        Flinks:"友情链接",
        qcode:"微信扫码快速登录",
        qcode1:"登录即代表您已同意 《服务协议》& 《隐私政策》",
        agreen:"已阅读并同意",
        agreen1:"患者知情同意书",
        agreen2:"隐私政策",
        needs:'工作人员将在3-5工作日与您联系，紧急需求可直接联系中心:0898-62799961',
        MessageConsultation:"留言咨询",
        latest:"最新",
        hottest:"最热",
        subscribe:"订阅",
    },
    disease:{
        DiseaseTopic:'专题',
        classificationOfDisease:'疾病分类',
    },
    drug:{
        DrugList:'药品列表',
        more:'阅读全文',
        label:'标签',
        classification:'分类',
        allData:'全部',
        UpcomingEvents:'活动预告',
        control:'管理订阅',
        cancelControl:'取消订阅'
    },
    medic:{
        CoreServices:'核心服务',
        PatientCounseling:'患者咨询',
    },
    exteam:{
        ExpertTeam:'专家团队',
        Department:'科室',
    },
    visitprocess:{
        VisitProcess:'就诊流程',
        TransportationMode:'交通方式',
        theBus:'公交路线',
        ParkShuttle:'园区穿梭车',
    },
    literature:{
        AcademicList:'学术列表',
    },
    no:{
        Thereiscurrentlynocontentavailable:'暂无内容',
        Youcanclickthebuttonbelowtoleaveamessageforconsultation:'可点击下方按钮留言咨询',
        MessageConsultation:'留言咨询',
        pleaseLogin:'请先登录!',
    },
    love:{
        EncyclopediaList:'百科列表',
    },
    policy:{
        PolicyList:'政策列表',
    },
    shout:{
        Listofrarewords:'罕话列表',
    },
    story:{
        NewsList:'新闻列表',
    },
    contact:{
        content:'感谢您对博鳌乐城维健罕见病临床医学中心 官方网站的关注，您可以拨打我们饿服务电话或邮件和我们取得联系，我们将竭诚为您提供令您满意的服务',
    },
    intro:{
        VisionAndMission:'愿景与使命',
        History:'发展历史',
        Partners:'合作机构',
        NewsCenter:'新闻中心',
        SeeMore:'查看更多',
    },
    details:{
        host:'主持人',
        LiveTime:'直播时间',
        WatchNow:'观看直播',
        WatchNow1:'未开始',
        WatchNow2:'观看回放',
        SeeMore:'活动直播介绍',
        Liveintroduction:'相关视频',
        MessageConsultation:'留言咨询',
        experts:'专家介绍',
        academicResearch:'学术研究',
        RelatedArticles:'相关文章',
        RelatedProducts:'相关产品',
        RelatedDrugs:'相关药物',
        RelatedExperts:'相关专家',
        latestNews:'最新新闻',
        LatestVideo:'最新视频',
        ClickThebuttonBelowtoContactUs:'点击留言咨询，与我们联系',
        subscribe:'点击订阅，第一时间获取相关信息',
        subscribe2:'订阅',
    },
    seek:{
        ConsultationType:"咨询类型"
    }
   
}